module.exports = {"361025100":"鳌溪镇","361025101":"公溪镇","361025102":"山砀镇","361025103":"龚坊镇","361025104":"戴坊镇","361025105":"牛田镇","361025106":"万崇镇","361025107":"增田镇","361025108":"招携镇","361025200":"湖溪乡","361025201":"罗陂乡","361025202":"湖坪乡","361025203":"南村乡","361025204":"谷岗乡","361025205":"金竹畲族乡","361025206":"大马头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361025.json
// module id = 1333
// module chunks = 0